import EmberObject from '@ember/object';

import * as OpAmpNegCurrent from './noise-sources/op-amp-neg-current';
import * as OpAmpPosCurrent from './noise-sources/op-amp-pos-current';
import * as OpAmpVoltage from './noise-sources/op-amp-voltage';
import * as R1 from './noise-sources/r1';
import * as R2 from './noise-sources/r2';
import * as R3 from './noise-sources/r3';
import * as R4 from './noise-sources/r4';
import * as R5 from './noise-sources/r5';
import FilterConstants from '../../../../filter-constants';

export default class DeliyannisBandPassNoiseSource extends EmberObject {
  c1 = null;
  c2 = null;
  r1 = null;
  r2 = null;
  r3 = null;
  r4 = null;
  r5 = null;
  opAmp = null;
  _r1Noise(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary) {
    var r1 = this.r1;
    var c1 = this.c1;
    var r5 = this.r5;
    var complexAlphaMinus = R1.computeComplexAlphaMinus(complexDenominator, c1, r1, r5, rx, sImaginary);
    var complexFF = R1.computeComplexFF(complexRParallel, r1);
    var value = Math.sqrt(r1 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _r2Noise(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary) {
    var c1 = this.c1;
    var r2 = this.r2;
    var r5 = this.r5;
    var complexAlphaMinus = R2.computeComplexAlphaMinus(complexDenominator, c1, r2, r5, rx, sImaginary);
    var complexFF = R2.computeComplexFF(complexRParallel, r2);
    var value = Math.sqrt(r2 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _r3Noise(filterAmplitude, complexRParallel) {
    var r3 = this.r3;
    var r4 = this.r4;
    var complexAlphaMinus = R3.computeComplexAlphaMinus(r3, r4);
    var complexFF = R3.computeComplexFF(complexRParallel, r3, r4);
    var value = Math.sqrt(r3 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _r4Noise(filterAmplitude, complexRParallel) {
    var r3 = this.r3;
    var r4 = this.r4;
    var complexAlphaMinus = R4.computeComplexAlphaMinus(r3, r4);
    var complexFF = R4.computeComplexFF(complexRParallel, r3, r4);
    var value = Math.sqrt(r4 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _r5Noise(filterAmplitude, complexDenominator, rx, sImaginary) {
    var c1 = this.c1;
    var r5 = this.r5;
    var complexAlphaMinus = R5.computeComplexAlphaMinus(complexDenominator, c1, rx, sImaginary);
    var complexFF = R5.computeComplexFF();
    var value = Math.sqrt(r5 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _opAmpNegCurrent(filterAmplitude, complexRParallel) {
    var r3 = this.r3;
    var r4 = this.r4;
    var complexAlphaMinus = OpAmpNegCurrent.computeComplexAlphaMinus(r3, r4);
    var complexFF = OpAmpNegCurrent.computeComplexFF(complexRParallel, r3, r4);
    var value = this.opAmp.iNoise;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _opAmpPosCurrent(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary) {
    var c1 = this.c1;
    var r5 = this.r5;
    var complexAlphaMinus = OpAmpPosCurrent.computeComplexAlphaMinus(complexDenominator, c1, r5, rx, sImaginary);
    var complexFF = OpAmpPosCurrent.computeComplexFF(complexRParallel);
    var value = this.iNoise;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _opAmpVoltage(filterAmplitude) {
    var complexAlphaMinus = OpAmpVoltage.computeComplexAlphaMinus();
    var complexFF = OpAmpVoltage.computeComplexFF();
    var value = this.vNoise;
    var magnitude = filterAmplitude.computeMagnitude(complexAlphaMinus, complexFF);
    var result = value * magnitude;
    return result;
  }

  totalNoise(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary) {
    var r1Noise = this._r1Noise(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary);
    var r2Noise = this._r2Noise(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary);
    var r3Noise = this._r3Noise(filterAmplitude, complexRParallel);
    var r4Noise = this._r4Noise(filterAmplitude, complexRParallel);
    var r5Noise = this._r5Noise(filterAmplitude, complexDenominator, rx, sImaginary);
    var opAmpNegCurrent = this._opAmpNegCurrent(filterAmplitude, complexRParallel);
    var opAmpPosCurrent = this._opAmpPosCurrent(filterAmplitude, complexDenominator, complexRParallel, rx, sImaginary);
    var opAmpVoltage = this._opAmpVoltage(filterAmplitude);
    var noiseArray = [r1Noise, r2Noise, r3Noise, r4Noise, r5Noise, opAmpNegCurrent, opAmpPosCurrent, opAmpVoltage];
    var sumOfSquares = 0;

    noiseArray.forEach((item) => {
      sumOfSquares += item * item;
    });

    var result = Math.sqrt(sumOfSquares);
    return result;
  }
}
